import React, { useState } from "react";
import { Switch } from "antd";
import { useDispatch } from "react-redux";
import { MdEdit } from "react-icons/md";
import { categoryUpdate } from "../../redux/Category/CategorySlice";

const SingleCategoryCard = ({ data }) => {
  const dispatch = useDispatch();

  const statusChange = async (checked, data) => {
    if (data) {
      const formData = {
        categoryId: data._id,
        status: checked,
      };
      const updateCat = await dispatch(categoryUpdate(formData));
    }
  };

  return (
    <>
      <div className="cat_list_dis_box">
        <div className="cat_lst_image_box">
          <img src={data.desktopImage} alt="logo" />
        </div>
        <div className="status_box">
          <h5 className="line_clamp">{data.name}</h5>
          <Switch
            value={data.status}
            onChange={(e) => statusChange(e, data)}
            style={data.status ? { backgroundColor: "#3c9daa" } : {}}
          />
        </div>
        <div className="catdisc ">
          <h5 className="line_1_clamp">{data.name}</h5>
        </div>

        <div className="edit_cat_ico">
          <MdEdit />
        </div>
      </div>
    </>
  );
};

export default SingleCategoryCard;
